<template>
  <div class="px-0 d-flex flex-column" style="background-color: #FFFFFF; min-height: 100vh">
    <Navigation
        @logout="showLogOutDialog = true"
        @onClickAppBarIcon="drawerOpen = !drawerOpen"
        :hasLogo="true"
        width="100%"
        v-if="!$vuetify.breakpoint.xs"
    />
    <MobileNavBar v-else/>
    <v-row
        align="start"
        class="mt-10 mb-4 mx-0 px-0"
        v-if="!blogNotFound && !loading"
        :style="{ marginTop: $vuetify.breakpoint.xs ? '8vh' : '' }"
    >
      <v-col cols="12" class="image-card-container mx-0">
        <v-img
            :src="blog.image ? blog.image : defaultBlogCover"
            lazy-load="true"
            class="blog-image"
            width="100%"
        />
        <div
            v-if="blog && !loading"
            class="blog-title text-truncate"
            :style="{ left: $vuetify.breakpoint.xs ? '1em' : '13em', top: $vuetify.breakpoint.xs ? '15vh' : '25vh'}"
        >
          <h1
              class="my-2 text-wrap font-weight-bold"
              data-testid="blog-title"
              v-html="blog.title === '...' ? '' : blog.title"
              :style="{ fontSize: $vuetify.breakpoint.xs ? '2.3em' : '4em'}"
          />
        </div>
      </v-col>
      <v-col cols="12" lg="10" class="mx-lg-auto mx-0">
        <v-row class="mx-2 mx-md-5 mx-sm-5 mx-lg-5 align-center pa-5">
          <v-col cols="12" md="auto" lg="auto" sm="auto" style="color: #D0D0D0">{{ createdAt }}</v-col>
          <v-col class="d-flex flex-column flex-md-row flex-lg-row flex-sm-row align-md-center justify-space-between">
            <v-chip-group>
              <div v-for="(tag, i) in blog.tags" :key="i">
                <v-chip
                    outlined
                    color="primary"
                    v-if="tag.name !== 'EMPTY_TAG'"
                    @click="searchForTag(tag.name)"
                >
                  {{ tag.name }}
                </v-chip>
              </div>
              <v-chip
                  v-if="blog.grade_level"
                  :color=" blog.grade_level.color_code ? blog.grade_level.color_code : 'primary'"
                  class="white--text text-capitalize"
              >
                {{ blog.grade_level.grade }}
              </v-chip>
              <v-chip color="primary" class="text-capitalize">{{blog.read_time}}</v-chip>
            </v-chip-group>
            <div v-if="isAuthenticated && blog.owner.id === user.id" style="font-family: Montserrat">
              <v-btn class="px-1 text-capitalize" color="primary" outlined @click="goToEditBlog()" data-testid="go-to-edit-blog">
                <v-icon color="primary">mdi-content-save-edit-outline</v-icon>
                Edit Blog
              </v-btn>
<!--              <v-btn class="px-0 ml-2 text-capitalize" text @click="deleteBlog()">-->
<!--                <v-icon color="red">mdi-delete</v-icon>-->
<!--                Delete-->
<!--              </v-btn>-->
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-2 mx-md-5 mx-sm-5 mx-lg-5 justify-space-between">
          <v-col cols="12" md="7" lg="7" class="pr-5">
            <div
                class="pa-sm-5 mb-6 body"
                :style="{ height: readMore ? 'auto' : '41em !important', overflowY: 'hidden'}"
                v-html="blog.body === '...' ? '' : blog.body"
            />
            <div class="read-more" v-if="blog.body">
              <v-chip
                  color="primary"
                  v-if="!readMore && blog.body.length && blog.body.length > 2000"
                  @click="readMore = true"
                  elevation="0"
              >
                Read More
              </v-chip>
            </div>
            <div class="font-italic">
              <p style="color: #808080;" class="pb-0 mb-0">
                Article by  <ProfileNameOrUserName :user="blog.owner" color="#808080"/>
              </p>
              <router-link :to="`/mentors/${blog.owner.uuid}`" style="color: black" class="text-decoration-none mt-0 pt-0">
                <p>See more by  <ProfileNameOrUserName :user="blog.owner" color="black"/></p>
              </router-link>
            </div>
            <v-divider style="border-top:  .18em solid #C2C2C2;"/>
            <div class="d-flex flex-row mt-4 mb-10" style="color: #8B8585;">
              <v-btn
                  v-if="!$vuetify.breakpoint.xs"
                  elevation="0"
                  small
                  @click="isAuthenticated ? likeBlog() : showAuthDialog()"
                  class="text-no-wrap d-flex flex-row mt-0 text-capitalize like-bookmark-btn"
              >
                <v-icon color="primary">
                  {{ blog.has_liked ? "mdi-heart" : "mdi-heart-outline" }}
                </v-icon>
                <div class="ml-1">
                  {{ kFormatter(blog.blog_likes !== undefined ? blog.blog_likes : 0) }}
                  <span class="mx-0 px-0">Likes</span>
                </div>
              </v-btn>
              <v-btn
                  v-if="!$vuetify.breakpoint.xs"
                  elevation="0"
                  small
                  @click="isAuthenticated ? bookMarkBlog() : showAuthDialog()"
                  class="text-no-wrap d-flex flex-row mt-0 ml-5 text-capitalize like-bookmark-btn"
              >
                <v-icon color="primary">
                  {{ blog.has_bookmarked ? "mdi-bookmark" : "mdi-bookmark-outline" }}
                </v-icon>
                <div class="ml-1">
                  {{kFormatter(blog.blog_bookmarks ? blog.blog_bookmarks : 0) }}
                  <span class="mx-0 px-0">Bookmarks</span>
                </div>
              </v-btn>
              <v-menu right min-width="250px" offset-x rounded>
                <template v-slot:activator="{ on }">
                  <v-btn
                      class="text-no-wrap d-flex flex-row mt-0 ml-5 text-capitalize like-bookmark-btn"
                      v-if="!$vuetify.breakpoint.xs"
                      elevation="0"
                      v-on="on"
                      small
                  >
                    <v-icon color="primary">mdi-share</v-icon>
                    <span class="ml-1 px-0">Share</span>
                  </v-btn>
                </template>
                <v-card style="font-family: Montserrat, sans-serif;">
                  <v-list-item-content>
                    <div class="text-left d-flex flex-column">
                      <v-list-item>
                        <v-btn
                            class="d-flex justify-space-between text-capitalize"
                            v-clipboard:copy="blogUrl"
                            v-clipboard:success="onBlogUrlCopy"
                            v-clipboard:error="onBlogUrlError"
                            block
                            text
                        >
                          <div class="font-weight-bold">Copy Link</div>
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </v-list-item>
                      <v-list-item
                          class="py-0 my-0"
                          v-for="(item, i) in shareToLinks"
                          :key="i"
                      >
                        <v-btn block text class="text-left">
                          <a
                              class="text-decoration-none text-left text-capitalize"
                              style="color: black; width: 100%"
                              :href="`${item.href + blogUrl}`"
                              target="_blank"
                          >
                            Share to {{ item.name }}
                          </a>
                        </v-btn>
                      </v-list-item>
                    </div>
                  </v-list-item-content>
                </v-card>
              </v-menu>
              <v-btn small elevation="0" class="like-bookmark-btn  text-capitalize text-no-wrap d-flex flex-row ml-5">
                <img :src="commentsIcon" alt="likes-icon" class="like-comment-icon" />
                <div class="ml-1">
                  {{kFormatter(blog.comments.length ? blog.comments.length : 0) }}
                  <span class="mx-0 px-0">Comments</span>
                </div>
              </v-btn>
            </div>
            <div class="comments-container" v-if="blog.comments.length">
              <Comment
                  v-for="(comment, index) in blog.comments"
                  :key="comment.id"
                  :comment="comment"
                  :comment-index="index"
                  :show-border="index !== (blog.comments.length -1)"
                  :commentEditBody="commentEditBody"
                  :commentEditIndex="commentEditIndex"
                  :updateCommentLoading="updateCommentLoading"
                  @cancelEdit="cancelEdit"
                  @onEditorChange="onEditorChange"
                  @setDeleteMode="setDeleteMode"
                  @setEditMode="setEditMode"
                  @updateComment="updateComment"
              />
            </div>
            <div>
              <quill-editor
                  ref="myQuillEditor"
                  :options="editorOptions"
                  v-model="commentBody"
                  :disabled="commentSaveLoading"
              />
              <v-row class="my-2 ml-1 pl-0 d-flex flex-row align-center justify-end">
                <v-btn
                    :disabled="commentSaveLoading || !commentBody"
                    :loading="commentSaveLoading"
                    color="primary"
                    elevation="0"
                    class="text-capitalize mr-2 ml-0"
                    style="font-family: Montserrat,serif"
                    @click="isAuthenticated ? addComment() : showAuthDialog()"
                >
                  Save
                </v-btn>
              </v-row>
            </div>
          </v-col>
          <v-col
              cols="4"
              class="hidden-sm-and-down pl-5 subscriptions"
          >
            <v-card flat style="background-color: #F2F2F2; border-radius: 0"  class="pa-4 mb-3">
              <v-card-title class="subscribe-header pb-0">About Blog Author</v-card-title>
              <v-card-text class="">
                <v-list class="d-flex flex-column justify-space-around text-no-wrap" style="font-size: 1.1em; background-color: transparent">
                  <v-list-item>
                    <strong class="mr-2">Name: </strong><h3><ProfileNameOrUserName :user="blog.owner"/></h3>
                  </v-list-item>
                  <v-list-item v-if="blog.owner.profile.bio">
                    <strong class="mr-2">Bio: </strong>{{ blog.owner.profile.bio || "404" }}
                  </v-list-item>
                  <v-list-item v-if="country">
                    <strong class="mr-2">Where Am I from:</strong>{{ country }}
                  </v-list-item>
                  <v-list-item>
                    <strong class="mr-2">What I Do:</strong>{{ account }}
                  </v-list-item>
                  <v-list-item class="">
                    <strong class="mr-2">Joined:</strong>{{ $moment(blog.owner.profile.created).format("MMMM Do YYYY") }}
                  </v-list-item>
                </v-list>
                <v-img
                    v-if="blog.owner.profile.avatar"
                    :src="blog.owner.profile.avatar"
                    style="width: 100%; height: 15em"
                    alt="blog owners pic"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn
                    v-if="isAuthenticated && user.id !== blog.owner.id"
                    :loading="followLoading"
                    :outlined="blog.owner.profile.has_followed"
                    @click="followMentor()"
                    elevation="0"
                    color="primary"
                    style="width: 100%; color: white; font-size: 1.1em"
                >
                  {{ !blog.owner.profile.has_followed ? "FOLLOW" : "UNFOLLOW" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-0 px-0 hidden-sm-and-up" v-if="!blogNotFound && !loading">
      <v-col cols="12" class="subscriptions">
        <v-card flat style="background-color: #F2F2F2; border-radius: 0"  class="pa-4 mb-3">
          <v-card-title class="subscribe-header pb-0">About Blog Author</v-card-title>
          <v-card-text class="">
            <v-list class="d-flex flex-column justify-space-around text-no-wrap" style="font-size: 1.1em; background-color: transparent">
              <v-list-item>
                <strong class="mr-2">Name: </strong><h3><ProfileNameOrUserName :user="blog.owner"/></h3>
              </v-list-item>
              <v-list-item v-if="blog.owner.profile.bio">
                <strong class="mr-2">Bio: </strong>{{ blog.owner.profile.bio || "404" }}
              </v-list-item>
              <v-list-item v-if="country">
                <strong class="mr-2">Where Am I from:</strong>{{ country }}
              </v-list-item>
              <v-list-item>
                <strong class="mr-2">What I Do:</strong>{{ account }}
              </v-list-item>
              <v-list-item class="">
                <strong class="mr-2">Joined:</strong>{{ $moment(blog.owner.profile.created).format("MMMM Do YYYY") }}
              </v-list-item>
            </v-list>
            <v-img
                v-if="blog.owner.profile.avatar"
                :src="blog.owner.profile.avatar"
                style="width: 100%; height: 15em"
                alt="blog owners pic"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
                v-if="isAuthenticated && user.id !== blog.owner.id"
                :loading="followLoading"
                :outlined="blog.owner.profile.has_followed"
                @click="followMentor()"
                elevation="0"
                color="primary"
                style="width: 100%; color: white; font-size: 1.1em"
            >
              {{ !blog.owner.profile.has_followed ? "FOLLOW" : "UNFOLLOW" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="loading" style="padding-top: 8em" class="mx-0 px-0">
      <v-skeleton-loader
          :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
          height="60vh"
          class="my-5 mx-auto"
          type="card,article,article,article,article,article,article,article,article,article"
          data-testid="blog-loader"
      />
    </v-row>
    <v-row v-else-if="!loading && blogNotFound" class="my-10">
        <NotFound data-testid="blog-not-found-card" v-if="blogNotFound" resourceItem="Blog was not Found" />
    </v-row>
    <div class="mt-auto mx-0 px-0">
      <Footer/>
    </div>
    <!--- delete blog dialog -->
    <v-dialog data-testid="delete-blog-dialog" v-model="reveal" max-width="600" persistent>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <v-card class="ma-auto pa-lg-2 deleteAccount" elevation="1">
        <v-card-title class="h2 title text-center heading">
          Delete Blog
        </v-card-title>
        <v-card-subtitle class="mt-2 px-6 font-weight-medium">
          Are you sure of this action? <br />
          This blog will be deleted along with all attached comments
        </v-card-subtitle>
        <v-card-actions class="mx-lg-2 mt-5">
          <v-spacer />
          <v-btn
              :disabled="loading"
              color="primary"
              small
              @click="reveal = false"
          >
            Cancel
          </v-btn>
          <v-btn
              :disabled="loading"
              class="white--text"
              color="red"
              outlined
              small
              @click="deleteBlog()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete comment dialog-->
    <DeleteComment
        :deleteDialog="deleteCommentDialog"
        :deleteLoading="deleteCommentLoading"
        @cancelDelete="deleteCommentDialog = false"
        @deleteItem="deleteComment"
        deleteType="comment"
    />
    <v-bottom-navigation
        v-if="$vuetify.breakpoint.xs && !loading && !blogNotFound"
        v-model="value"
        fixed
        style="font-family: Montserrat, sans-serif"
    >
      <v-btn value="views">
        <span>{{ kFormatter(blog.blog_views) }}</span>
        <v-icon color="primary">mdi-eye</v-icon>
      </v-btn>
      <v-btn value="like">
        <span>Like</span>
        <v-icon
          color="primary"
          @click="isAuthenticated ? likeBlog() : showAuthDialog()"
        >
          {{ blog.has_liked ? "mdi-heart" : "mdi-heart-outline" }}
        </v-icon>
      </v-btn>
      <v-btn value="bookmark">
        <span>Save</span>
        <v-icon
          color="primary"
          @click="isAuthenticated ? bookMarkBlog() : showAuthDialog()"
        >
          {{ blog.has_bookmarked ? "mdi-bookmark" : "mdi-bookmark-outline" }}
        </v-icon>
      </v-btn>
      <v-btn value="more">
        <span>More</span>
        <v-menu right min-width="250px" offset-x rounded>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="primary">mdi-dots-horizontal</v-icon>
          </template>
          <v-card style="font-family: Montserrat, sans-serif">
            <v-list-item-content>
              <div class="text-left d-flex flex-column">
                <v-list-item>
                  <v-btn
                      class="d-flex justify-space-between text-capitalize"
                      v-clipboard:copy="blogUrl"
                      v-clipboard:success="onBlogUrlCopy"
                      v-clipboard:error="onBlogUrlError"
                      block
                      text
                  >
                    <div class="font-weight-bold">Copy Link</div>
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </v-list-item>
                <v-list-item
                    class="py-0 my-0"
                    v-for="(item, i) in shareToLinks"
                    :key="i"
                >
                  <v-btn block text class="text-left">
                    <a
                        class="text-decoration-none text-left text-capitalize"
                        style="color: black; width: 100%"
                        :href="`${item.href + blogUrl}`"
                        target="_blank"
                    >
                      Share to {{ item.name }}
                    </a>
                  </v-btn>
                </v-list-item>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import { constructDate } from "@/utilz/date";
import { mapGetters } from "vuex";
import logo from "@/assets/blue-logo.png";
import Navigation from "@/components/Navigation.vue";
import DeleteComment from "@/components/DeleteItem.vue";
import countries from "@/constants/countries.json";
import { kFormatter } from "@/utilz/kFormatter";
import authDialogMixin from "@/mixins/authDialogMixin";
import defaultBlogCover from "@/assets/default-blog-cover.png"
import {getDisplayNameOrEmail} from "@/utilz/dispalyNameOrEmail";
import commentsIcon from "@/assets/commenting.svg"
import likeIcon from "@/assets/likes-icon.svg"
import Comment from "@/components/Comment";
import NotFound from "@/components/NotFound";
import Footer from "@/components/Footer";
import MobileNavBar from "@/components/MobileNavBar";
import ProfileNameOrUserName from "@/components/profileNameOrUserName";

export default {
  mixins: [authDialogMixin],
  components: {
    ProfileNameOrUserName,
    MobileNavBar,
    Footer,
    Comment,
    Navigation,
    DeleteComment,
    NotFound
  },
  data() {
    return {
      commentsIcon,
      likeIcon,
      defaultBlogCover,
      loading: false,
      followLoading: false,
      showLogOutDialog: false,
      countries,
      item: 1,
      drawerOpen: true,
      logo,
      ownerBlogs: [],
      fetchMoreFromOwnerLoading: false,
      metaInfo: {},
      blogNotFound: false,
      blogUrl: window.location.href,
      shareToLinks: [
        {
          name: "Twitter",
          href: "https://twitter.com/share?url=",
        },
        {
          name: "LinkedIn",
          href: "https://www.linkedin.com/shareArticle?mini=true&url=",
        },
        {
          name: "Reddit",
          href: "https://reddit.com/submit?url=",
        },
        {
          name: "Hacker News",
          href: "https://news.ycombinator.com/submitlink?url=",
        },
        {
          name: "Facebook",
          href: "https://www.facebook.com/sharer.php?u=",
        },
      ],
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["link", "image", "video"],
              ["bold", "italic", "underline"],
              ["blockquote", "code-block"],
            ],
          },
        },
      },
      value: "",
      blog: {
        blog_bookmarks: "",
        blog_likes: "",
        has_bookmarked: false,
        has_liked: false,
        comments: [
          {
            owner: {
              id: "",
              email: "",
              profile: {
                avatar: "",
              },
            },
          },
        ],
        owner: {
          id: "",
          email: "",
          profile: {
            avatar: "",
          },
          account_types: [],
        },
      },
      slug: "",
      showCommentSection: false,
      deleteCommentDialog: false,
      updateCommentLoading: false,
      deleteCommentIndex: null,
      deleteCommentLoading: false,
      isEditingComment: false,
      reveal: false,
      comments: [],
      commentBody: null,
      commentSaveLoading: false,
      commentEditIndex: null,
      commentEditBody: null,
      content: "",
      tags: [],
      readMore: false,
    };
  },
  metaInfo() {
    return {
      title: this.blog?.title,
      url: window.location.href,
      meta: [
        { name: "title", content: this.blog.title },
        {
          name: "description",
          content: this.blog.description || this.blog?.body?.substring(0, 20),
        },
        //Facebook
        { name: "og:type", content: "Website" },
        { name: "og:title", content: this.blog.title },
        {
          name: "og:description",
          content: this.blog.description || this.blog?.body?.substring(0, 20),
        },
        { name: "og:image", content: this.blog.image || this.logo },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: window.location.href },
        { name: "twitter:title", content: this.blog.title },
        {
          name: "twitter:description",
          content: this.blog.description || this.blog?.body?.substring(0, 20),
        },
        { name: "twitter:image", content: this.blog.image || this.logo },
      ],
    };
  },
  async mounted() {
    this.slug = this.$router.history.current.params.slug;
    try {
      this.loading = true;
      this.fetchMoreFromOwnerLoading = true;
      const response = await this.axios.get(
        `blogs/posts/${this.slug}?format=json`
      );
      this.blog = response.data;
      this.loading = false;
      if (this.blog.body.length > 2000) this.readMore = false;
      else this.readMore = true;
      this.$analytics.logEvent("view_blog", {
        user: this.user || "no logged in user",
        time: new Date(),
        url: window.location.href,
        version: process.env.VUE_APP_VERSION,
        environment: process.env.VUE_APP_ENVIRONMENT,
      });
    } catch (error) {
      this.loading = false;
      this.blogNotFound = true;
      if (error.message !== "Request failed with status code 404") {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    }
    await this.fetchMoreFromOwner();
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    createdAt() {
      const date = new Date(this.blog.created);
      return constructDate(date.getDate(), date.getMonth(), date.getFullYear());
    },
    country() {
      return this.countries.find(
        ({ code }) =>
          code.toLowerCase() ===
          this.blog.owner?.profile?.country?.toLowerCase()
      )?.name;
    },
    account() {
      return this.blog.owner?.account_types[0]?.name;
    },
  },
  methods: {
    getDisplayNameOrEmail(user) {
      return getDisplayNameOrEmail(user);
    },
    goToEditBlog() {
      this.$router.push(`/blogs/${this.slug}/edit/`);
    },
    async fetchMoreFromOwner() {
      try {
        this.fetchMoreFromOwnerLoading = true;
        const response = await this.axios.get(
          `blogs/posts/?author=${this.blog.owner.email}&limit=6`
        );
        this.ownerBlogs = [...new Set(response.data.results)];
        this.ownerBlogs = this.ownerBlogs.filter(
          (blog) => blog.slug !== this.blog.slug
        );
      } catch (error) {
        this.fetchMoreFromOwnerLoading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.fetchMoreFromOwnerLoading = false;
      }
    },
    async deleteBlog() {
      try {
        this.loading = true;
        await this.axios.delete(`/blogs/posts/${this.blog.slug}/`);
        this.loading = false;
        this.reveal = false;
        this.$snackbar.showMessage({
          content: "Blog post deleted successfully",
          color: "success",
        });
        this.$analytics.logEvent("delete_blog", {
          user: this.user.uuid || "no logged in user",
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
        await this.$router.push("/blogs");
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async addComment() {
      try {
        if (this.isEditingComment) {
          this.cancelEdit();
        }
        this.commentSaveLoading = true;
        const data = {
          body: this.commentBody,
          post: this.blog.id,
        };
        const res = await this.axios.post(`blogs/comments/`, data);
        this.blog.comments = [res.data, ...this.blog.comments];
        this.commentBody = null;
        this.$snackbar.showMessage({
          content: "Your comment was added successfully",
          color: "success",
        });
        this.$analytics.logEvent("add_blog_comment", {
          comment: res.data.body,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.commentSaveLoading = false;
      }
    },
    async updateComment() {
      try {
        this.updateCommentLoading = true;
        const data = {
          body: this.commentEditBody,
          post: this.blog.id,
        };
        const id = this.blog.comments[this.commentEditIndex].id;
        const res = await this.axios.patch(`blogs/comments/${id}/`, data);
        const comments = this.blog.comments;
        comments[this.commentEditIndex] = res.data;
        this.blog.comments = [...comments];
        this.commentEditBody = null;
        this.$snackbar.showMessage({
          content: "Your comment was updated successfully",
          color: "success",
        });
        this.$analytics.logEvent("update_blog_comment", {
          comment: this.blog.comments[this.commentEditIndex].body,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
        this.cancelEdit();
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.updateCommentLoading = false;
      }
    },
    setEditMode(index) {
      if (!this.isEditingComment) {
        this.isEditingComment = true;
        this.commentEditBody = this.blog.comments[index].body;
        this.commentEditIndex = index;
      } else {
        this.cancelEdit();
      }
    },
    cancelEdit() {
      this.isEditingComment = false;
      this.commentEditBody = null;
      this.commentEditIndex = null;
    },
    setDeleteMode(index) {
      this.deleteCommentIndex = index;
      this.deleteCommentDialog = true;
    },
    async deleteComment() {
      try {
        this.deleteCommentLoading = true;
        const id = this.blog.comments[this.deleteCommentIndex].id;
        await this.axios.delete(`blogs/comments/${id}/`);
        this.blog.comments = [
          ...this.blog.comments.filter((_, i) => i !== this.deleteCommentIndex),
        ];
        this.deleteCommentIndex = null;
        this.deleteCommentDialog = false;
        this.$snackbar.showMessage({
          content: "Your comment was deleted successfully",
          color: "success",
        });
        this.$analytics.logEvent("delete_blog_comment", {
          comment: this.blog.comments[this.deleteCommentIndex].id,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.deleteCommentLoading = false;
      }
    },
    async likeBlog() {
      try {
        await this.axios.post(`blogs/likes/${this.blog.slug}/`,);
        const { has_liked, blog_likes } = this.blog;
        this.blog = {
          ...this.blog,
          blog_likes: !has_liked ? blog_likes + 1 : blog_likes - 1,
          has_liked: !has_liked,
        };
        this.$analytics.logEvent("like_blog", {
          blog: this.blog.slug,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async bookMarkBlog() {
      try {
        await this.axios.post(`blogs/bookmarks/${this.blog.slug}/`,);
        const { has_bookmarked, blog_bookmarks } = this.blog;
        this.blog = {
          ...this.blog,
          blog_bookmarks: !has_bookmarked
            ? blog_bookmarks + 1
            : blog_bookmarks - 1,
          has_bookmarked: !has_bookmarked,
        };
        this.$analytics.logEvent("bookmark_blog", {
          blog: this.blog.slug,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async followMentor() {
      try {
        this.followLoading = true;
        await this.axios.post(`users/following/?uuid=${this.blog.owner.uuid}`, {
          token: localStorage.getItem("access_token"),
        });
        const { profile } = this.blog.owner;
        this.blog.owner = {
          ...this.blog.owner,
          profile: { ...profile, has_followed: !profile.has_followed },
        };
        this.followLoading = false;
        this.$analytics.logEvent("follow_mentor", {
          mentor: this.blog.owner.uuid,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.followLoading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    searchForTag(tagName) {
      this.$router
        .push({ path: `/blogs/search?q=${tagName.trim()}` })
        .catch(() => {});
    },
    onEditorChange(val) {
      this.commentEditBody = val;
    },
    kFormatter(value) {
      return kFormatter(value);
    },
    onBlogUrlCopy() {
      this.$snackbar.showMessage({
        content: "Blog link copied",
        color: "success",
      });
    },
    onBlogUrlError() {
      this.$snackbar.showMessage({
        content: "Blog link not copied",
        color: "warning",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.body {
  overflow-x: hidden;

  ::v-deep img {
    max-width: 100%;
    max-height: 50vw;
  }
  ::v-deep iframe {
    max-width: 100%;
  }
  ::v-deep video {
    max-width: 100%;
  }
  ::v-deep pre {
    font-style: italic;
    font-size: .9em;
    max-width: 98%;
    overflow-x: auto;
    margin: 0;
    padding: 1em;
    background-color: rgb(248, 248, 242);
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .body {
    ::v-deep img {
      max-height: 100vw;
    }
  }
}

.read-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  height: 5em;
  background-color: white;
}

.like-bookmark-btn {
  background-color: transparent !important;
  color: #8B8585 !important;
  font-weight: 550 !important;
  font-family: Montserrat, sans-serif !important;
  font-size: .9em !important;
}

.like-bookmark-btn:hover {
  background-color: transparent !important;
}

.like-comment-icon {
  width: 1.3em !important;
  height: 1.3em !important;
  padding-right: .3em;
}

.subscriptions {
  .subscribe-header {
    font-family: Montserrat,serif;
    font-weight: bold;
    font-size: 1.6em;
    line-height: 60px;
  }
  ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none
  }
  ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    margin: 0
  }
}

.image-card-container {
  height: 32vh;
  width: 100%;
  elevation: higher;
  background-color: rgba(27, 70, 144, 0.5);

  .blog-image {
    position: relative;
    contain: inherit;
    height: inherit;
    width: 100%;
    opacity: 0.1;
  }
  .blog-title {
    position: absolute;
    background-color: transparent;
    color: #FFFFFF !important;
    text-transform: none;
    max-width: 95%;
    font-weight: bolder;
    font-family: Montserrat,serif;
  }
}
</style>
